import React from "react";
import { FEEDBACK_FORM_EMBED_SRC } from "./feedbackFormEmbed";
import "./Feedback.css";

export default function Feedback() {
  return (
    <div className="feedback-page">
      <div className="feedback-inner">
        <h1 className="feedback-title">Share Your Feedback</h1>
        <p className="feedback-desc">
          Help us improve PaceWerks. We read every response.
        </p>
        <div className="feedback-iframe-wrap">
          <iframe
            title="PaceWerks feedback form"
            src={FEEDBACK_FORM_EMBED_SRC}
            width="100%"
            height="800"
            frameBorder={0}
          >
            Loading…
          </iframe>
        </div>
      </div>
    </div>
  );
}
